import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationChargeLongFormBuilderSectionRescoreArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation ChargeLongFormBuilderSectionRescore($id: ID!) {
    chargeLongFormBuilderSectionRescore(id: $id)
  }
`;

type Variables = BackendMutationChargeLongFormBuilderSectionRescoreArgs;
type Result = boolean;

export const chargeLongFormBuilderSectionRescore = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
